import { render, staticRenderFns } from "./Qwdingding.vue?vue&type=template&id=1bfba4ba&scoped=true"
import script from "./Qwdingding.vue?vue&type=script&lang=js"
export * from "./Qwdingding.vue?vue&type=script&lang=js"
import style0 from "./Qwdingding.vue?vue&type=style&index=0&id=1bfba4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfba4ba",
  null
  
)

export default component.exports